import { cn } from "@/lib/tailwind";
import { FC } from "react";

interface FeedbackProps {
  type?: string;
  message?: string;
  className?: string;
}

const Feedback: FC<FeedbackProps> = (props) => {
  const { type, message, className } = props;

  return type ? (
    <div
      className={cn("mt-3 flex justify-center bg-error p-3 text-sm md:justify-start", className)}
      role="alert"
    >
      {message}
    </div>
  ) : (
    ""
  );
};

export default Feedback;
